import { useMemo } from "react";

export type Environment = "local" | "dev" | "prod";

export function getEnvironment(): Environment {
  if (typeof window === "undefined") {
    return "local";
  }

  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "local";
  }

  if (hostname === "dev.elayne.com" || hostname === "elayne-app-env-dev-elayne.vercel.app") {
    return "dev";
  }

  if (hostname === "app.elayne.com" || hostname === "elayne-app.vercel.app") {
    return "prod";
  }

  console.warn(`Unknown hostname: ${hostname}. Defaulting to 'local'`);
  return "local";
}

export function useGetEnvironment(): Environment {
  return useMemo(() => getEnvironment(), []);
}
